export class RequestDemo {
    npi: string;
    firstName: string;
    lastName: string;
    title: string;
    practiceName: string;
    address: string;
    phoneNumber: string;
    emailAddress: string;
    notes: string;
}
